<template>
  <div class="header pc" :class="headerClass">
    <div class="left" style="cursor: pointer" @click="topath('/home')">
      <!-- <img
        v-if="!state.isHeaderFixed"
        src="https://bunseninstitute.oss-cn-hangzhou.aliyuncs.com/files/images/picture_logo%403x.svg"
        alt=""
      /> -->
      <!-- http://shanghai-siggraph.oss-cn-hangzhou.aliyuncs.com/admin/images/20231016/siggraph logo-03 (2).svg -->
      <img
        v-if="!state.isHeaderFixed"
        src="http://shanghai-siggraph.oss-cn-hangzhou.aliyuncs.com/admin/images/20260508/siggraph logo 2.svg"
        alt=""
        style="max-width: 200px; width: 200px"
      />
    </div>
    <div class="center">
      <div
        @click="topath('/home')"
        :class="{
          click: isActive('/home'),
        }"
        v-if="state.isHeaderFixed"
      >
        {{ $t("header.home") }}
      </div>
      <div
        @click="topath('/about')"
        :class="{
          click: isActive('/about'),
        }"
      >
        {{ $t("header.About") }}
      </div>
      <div
        @click="topath('/committee')"
        :class="{
          click: isActive('/committee'),
        }"
      >
        {{ $t("header.Core_personnel") }}
      </div>
      <div
        @click="topath('/information')"
        :class="{
          click: isActive('/information'),
        }"
      >
        {{ $t("header.information") }}
      </div>
      <div
        class="active"
        :class="{
          click: isActive('/activity') || isActive('/Picture'),
        }"
      >
        <div class="act">
          <div @click="topath('/activity')">
            {{ $t("header.Upcoming_events") }}
          </div>
          <div @click="topath('/Picture')">
            {{ $t("header.Picture_at_a_glance") }}
          </div>
        </div>
        {{ $t("header.activity") }}
      </div>
      <div
        @click="topath('/joinus')"
        :class="{
          click: isActive('/joinus'),
        }"
      >
        {{ $t("header.join") }}
      </div>
      <div
        @click="topath('/contactus')"
        :class="{
          click: isActive('/contactus'),
        }"
      >
        {{ $t("header.contact") }}
      </div>
    </div>

    <div class="right">
      <div
        :class="state.lang == 'chinese_simplified' && 'clicks'"
        @click="changeLanguageSequence('chinese_simplified')"
      >
        {{ state.lang == "chinese_simplified" ? "中" : "CN" }}
      </div>
      <div
        :class="state.lang == 'english' && 'clicks'"
        @click="changeLanguageSequence('english')"
      >
        {{ state.lang == "chinese_simplified" ? "英" : "EN" }}
      </div>
    </div>
  </div>
  <div class="phone header" :class="headerClass">
    <div class="left">
      <!-- http://shanghai-siggraph.oss-cn-hangzhou.aliyuncs.com/admin/images/20260508/siggraph logo 2.svg -->
      <!-- https://bunseninstitutes.oss-cn-hangzhou.aliyuncs.com/files/images/siggraph%20logo-03.svg -->
      <img
        src="http://shanghai-siggraph.oss-cn-hangzhou.aliyuncs.com/admin/images/20260508/siggraph logo 2.svg"
        alt=""
        style="max-width: 112px; width: 112px; cursor: pointer"
        @click="topath('/home')"
      />
    </div>
    <div class="right">
      <img
        src="https://bunseninstitutes.oss-cn-hangzhou.aliyuncs.com/files/images/nav_icon_more.svg"
        alt=""
        style="width: 24px; padding: 0px; cursor: pointer"
        @click="toshows()"
      />
    </div>
    <van-popup
      v-model:show="state.show"
      position="right"
      class="my-vant-pop-menu"
      overlay-class="header-overlay"
    >
      <div>
        <div class="pcontent">
          <div class="right">
            <div
              :class="state.lang === 'chinese_simplified' ? 'clicks' : ''"
              @click="changeLanguageSequence('chinese_simplified')"
            >
              中
            </div>
            <div
              :class="state.lang === 'english' ? 'clicks' : ''"
              @click="changeLanguageSequence('english')"
            >
              英
            </div>
          </div>
          <div>
            <img
              src="https://bunseninstitutes.oss-cn-hangzhou.aliyuncs.com/files/images/nav_icon_wrong.svg"
              alt=""
              style="width: 18px; padding: 0px; cursor: pointer"
              @click="toshows()"
            />
          </div>
        </div>
        <div class="plist">
          <div
            @click="topath('/about')"
            :class="{
              click: isActive('/about'),
            }"
          >
            {{ $t("header.About") }}
          </div>
          <div
            @click="topath('/committee')"
            :class="{
              click: isActive('/committee'),
            }"
          >
            {{ $t("header.Core_personnel") }}
          </div>
          <div
            @click="topath('/information')"
            :class="{
              click: isActive('/information'),
            }"
          >
            {{ $t("header.information") }}
          </div>
          <div
            @click="topath('/activity')"
            :class="{
              click: isActive('/activity') || isActive('/Picture'),
            }"
          >
            {{ $t("header.activity") }}
          </div>
          <div
            @click="topath('/joinus')"
            :class="{
              click: isActive('/join'),
            }"
          >
            {{ $t("header.join") }}
          </div>
          <div
            @click="topath('/contactus')"
            :class="{
              click: isActive('/contact'),
            }"
          >
            {{ $t("header.contact") }}
          </div>
        </div>
      </div>
    </van-popup>
    <!-- 导航栏右侧更多图片 -->
    <!-- https://bunseninstitute.oss-cn-hangzhou.aliyuncs.com/files/images/nav_icon_wrong.svg -->
  </div>
</template>

<script setup>
import { reactive, computed, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useI18n } from "vue-i18n";
const { locale } = useI18n();
const router = useRouter();
const route = useRoute();
const state = reactive({
  lang: localStorage.getItem("language") || "english", // 默认语言为英文
  isHeaderFixed: false, // 是否固定在顶部
  scrollThreshold: 140, // 滚动到多少距离后切换样式
  show: false,
});
const topath = (e, f) => {
  state.show = false;
  if (f) {
    router.push({
      path: e,
      query: {
        type: f,
      },
    });
  } else {
    router.push(e);
  }
};
const isActive = (path) => {
  return route.path.includes(path);
};
const headerClass = computed(
  () => (state.isHeaderFixed && "fixed-header") || "default-header"
);
// 切换语言的函数
const changeLanguage = (language) => {
  let langCode = "";
  console.log(language, 123456);

  if (language == "chinese_simplified") {
    langCode = "cn"; // 设置简体中文
    state.lang = false;
    // console.log(locale.value, 9899988998);

    locale.value = "zh";
  } else if (language == "english") {
    langCode = "en"; // 设置英文
    state.lang = true;
    locale.value = "en";
  }

  console.log(langCode, 8869);

  // 确保传递正确的语言代码给 translate.changeLanguage
  if (langCode) {
    // 设置 localStorage 和 cookie
    localStorage.setItem("language", langCode);
    document.cookie = `locale=${langCode}`;

    // 更新状态并调用 translate.changeLanguage
    state.lang = language; // 更新 UI 显示语言
    if (typeof translate !== "undefined") {
      translate.changeLanguage(language);
    }
  } else {
    console.error("Invalid language selected");
  }
};

// 切换语言的过渡函数
const changeLanguageSequence = (targetLanguage) => {
  // 先切换到中文，然后再切换到目标语言
  // changeLanguage("chinese_simplified");
  setTimeout(() => {
    changeLanguage(targetLanguage);
  }, 100); // 延时切换目标语言
};
const handleScroll = () => {
  const scrollY = window.scrollY || window.pageYOffset;
  // console.log(scrollY, 989898);
  if (scrollY >= state.scrollThreshold) {
    state.isHeaderFixed = true;
  } else {
    state.isHeaderFixed = false;
  }
};
onMounted(() => {
  window.addEventListener("scroll", handleScroll);
  const browserLang = navigator.language || navigator.userLanguage;
  if (browserLang.includes("zh")) {
    changeLanguage("chinese_simplified");
  } else {
    changeLanguage("english");
  }
});
const toshows = () => {
  state.show = !state.show;
};

const setlang = (e) => {
  if (e == "zh") {
    state.lang = false;
  } else {
    state.lang = true;
  }
  locale.value = e;
};
</script>
<style lang="scss">
.van-popup {
  height: 100vh;
  width: 100%;
  color: #fff;
  background: #4155d9 !important;
  padding: 52px 44px;
}
</style>

<style lang="scss" scoped>
.active {
  position: relative;
  .act {
    display: none;
    opacity: 0;
    position: absolute;
    // display: flex;
    flex-direction: column;
    // transition: all 0.5s;
    padding: 20px;
    box-sizing: border-box;
    background: #ed765c;
    color: #fff;
    width: 140px;
    top: 57px;
    right: 10px;
    :nth-child(1) {
      margin-bottom: 16px;
    }

    :nth-child(n) {
      font-size: 14px !important;
      font-weight: 400 !important;
      line-height: 18px;
      &:hover {
        color: #4155d9;
      }
      &::after {
        display: none !important;
      }
    }
  }
}
@import "@/sass/index.scss";
.phone {
  display: none !important;
}
.header {
  color: #fff;
  max-width: 1176px;
  height: 100px;
  margin: 0 auto;
  background: #4155d9;
  display: flex;
  padding: 25px 66px;
  box-sizing: border-box;
  justify-content: space-between;
  align-items: center;
  position: relative;
  top: -100px;
  // transform: translate(30px,0px);
  z-index: 1;
  transition: all 0.3s;
  .left {
    line-height: 10px;
    // @include fontstyle(#fff, 18px, 800, pointer);
    img {
      &:hover {
        opacity: 0.5;
      }
    }
  }
  .center {
    display: flex;
    line-height: 50px;
    .active:hover .act {
      display: block !important;
      opacity: 1;
    }
    :hover {
      color: #ed765c;
    }
    .act {
      &:hover {
        color: #fff;
      }
    }
    :nth-child(n) {
      //   padding: 0px 32px;
      display: flex;
      align-items: center;
      font-size: 16px;
      cursor: pointer;
      font-weight: 800;
      &::after {
        content: "";
        display: block;
        height: 16px;
        width: 1px;
        cursor: auto;
        background: #fff;
        margin: 0 32px;
      }
    }
    :last-child {
      &::after {
        display: none;
      }
    }
  }
  .right {
    display: flex;
    height: 20px;
    font-size: 14px;
    font-weight: 800;
    :nth-child(n) {
      padding: 0px 8px;

      line-height: 20px;
      cursor: pointer;
    }
  }
}
.default-header {
  top: 40px;
  // animation-name: example;
  // animation-duration: .3s;
  // transform: translate(30px,0px);
}
.fixed-header {
  position: fixed;
  height: 64px;
  left: 0;
  right: 0;
  z-index: 3;
  animation-name: example;
  top: 40px;
  animation-duration: 0.3s;
  /* 添加其他固定状态样式 */
}
@keyframes example2 {
  0% {
    top: 40px;
  }
  // 50% {
  //   top: 20px;
  // }
  100% {
    top: -40px;
  }
}
@keyframes example {
  0% {
    top: -100px;
  }
  // 50% {
  //   top: 20px;
  // }
  100% {
    top: 40px;
  }
}
.clicks {
  background: #fff;
  color: #3657db;
}
.click {
  color: #f4775e;
}
@media screen and (max-width: 1180px) {
  .pc {
    display: none;
  }
  .phone {
    display: flex !important;
    width: 90%;
    height: 60px;
    padding: 14px 24px;
  }
  .pcontent {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    &::after {
      content: "";
      display: block;
      width: 100%;
      height: 2px;
      background: #fff;
      margin: 26px 0px 24px 0px;
    }
  }
  .plist {
    text-align: left;
    @include fontstyle(#fff, 18px, 800, pointer);
    :nth-child(n) {
      margin-bottom: 20px;
    }
  }
}
// @media screen and (max-width: 800px) {
//   .pc {
//     display: none;
//   }
//   .phone {
//     display: flex !important;
//     width: 90%;
//     height: 60px;
//     padding: 14px 24px;
//   }
//   .pcontent {
//     display: flex;
//     justify-content: space-between;
//     flex-wrap: wrap;
//     &::after {
//       content: "";
//       display: block;
//       width: 100%;
//       height: 2px;
//       background: #fff;
//       margin: 26px 0px 24px 0px;
//     }
//   }
//   .plist {
//     text-align: left;
//     @include fontstyle(#fff, 18px, 800, pointer);
//     :nth-child(n) {
//       margin-bottom: 20px;
//     }
//   }
// }
</style>
